export default [
    "24 24",
    '<path fill="none" d="M18.9338 2.62875H2.99068V20.9338" stroke="var(--ci-primary-color, currentColor)" stroke-width="4.5"/>'
]

